'use client';

import { c as _c } from "react/compiler-runtime";
import { AnimateChildren, AnimateNumber, Heading, LayoutStack, WaveyWrapper } from 'design-system/client';
import { useTranslations, useLocale } from 'next-intl';
import type { FEPPContentDonation } from '../../types';
import { useProgressAndDonationsContext } from '../ProgressAndDonationsContext';
import DonationCard from './DonationCard';
import styles from './DonationFeed.module.css';
import Donations from './Donations';
function DonationFeed(t0) {
  const $ = _c(16);
  const {
    fundraisingEventId,
    donationFormUrl,
    receivedDonationsCount: receivedDonationsCount_,
    maxRows,
    initialDonations,
    initialDonationLimit
  } = t0;
  const t = useTranslations("nextjs.donation_feed");
  const locale = useLocale();
  const {
    donationCount
  } = useProgressAndDonationsContext();
  const receivedDonationsCount = donationCount ?? receivedDonationsCount_;
  let t1;
  if ($[0] !== locale || $[1] !== receivedDonationsCount || $[2] !== t) {
    t1 = t.rich("heading", {
      count: receivedDonationsCount.toLocaleString(locale),
      animated: _temp
    });
    $[0] = locale;
    $[1] = receivedDonationsCount;
    $[2] = t;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t1) {
    t2 = <Heading className={styles.heading} level="heading-sm" as="h2">{t1}</Heading>;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== donationFormUrl || $[7] !== fundraisingEventId || $[8] !== initialDonationLimit || $[9] !== initialDonations || $[10] !== maxRows || $[11] !== receivedDonationsCount) {
    t3 = receivedDonationsCount ? <Donations fundraisingEventId={fundraisingEventId} receivedDonationsCount={receivedDonationsCount} maxRows={maxRows} initialDonations={initialDonations} initialDonationLimit={initialDonationLimit} donationCount={receivedDonationsCount} /> : <DonationCard cta={true} donationFormUrl={donationFormUrl} />;
    $[6] = donationFormUrl;
    $[7] = fundraisingEventId;
    $[8] = initialDonationLimit;
    $[9] = initialDonations;
    $[10] = maxRows;
    $[11] = receivedDonationsCount;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  let t4;
  if ($[13] !== t2 || $[14] !== t3) {
    t4 = <WaveyWrapper className={styles.wrapper}><LayoutStack className={styles.innerContainer}>{t2}{t3}</LayoutStack></WaveyWrapper>;
    $[13] = t2;
    $[14] = t3;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  return t4;
}
function _temp(chunks) {
  return <AnimateNumber animationDurationInMs={1500} maxNumberScale={1.3}>{chunks as AnimateChildren}</AnimateNumber>;
}
export default DonationFeed;